import React from 'react';

import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Currency } from '@/modules/common';
import { OrganizationFormValues } from '@/modules/onboarding/organization-setup';

interface CurrencySelectorProps {
  control: Control<OrganizationFormValues>;
  currencies: Currency[];
  isLoading: boolean;
}

export const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  control,
  currencies,
  isLoading,
}) => {
  const { t } = useTranslation(['authenticated.organization']);
  return (
    <FormField
      control={control}
      name="defaultCurrencyCode"
      render={({ field }) => (
        <FormItem className="flex min-w-0 flex-col">
          <FormLabel>{t('authenticated.organization:fields.currency')}</FormLabel>
          <Select
            onValueChange={value => {
              // Guard against Radix firing onValueChange("") during controlled value transitions
              if (!value) return;
              field.onChange(value);
            }}
            value={field.value || undefined}
            disabled={isLoading || !currencies}
          >
            <FormControl>
              <SelectTrigger className="[&>span]:truncate">
                <SelectValue placeholder={t('authenticated.organization:placeholders.currency')} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {currencies?.map(currency => (
                <SelectItem key={currency.code} value={currency.code} checkPosition="right">
                  {currency.toString()}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
